import { createFileRoute } from "@tanstack/react-router";
import { ScribePage } from "shared/components/global/Scribe/ScribePage";

/** @public */
export const Route = createFileRoute("/_auth/help/messages")({
    component: () => <ScribePage src="https://scribehow.com/page-embed/Composing_a_message__ow9kX-zFSGiT3ZhhMdQLsg" />,
});
